import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";
import { ClickUpService } from "src/app/shared/services/clickUp.service";
import {
  invokeCreateClickUpTask,
  resultCreateClickUpTask,
} from "./clickUp.actions";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { setAPIStatus } from "../apiState.interface";

@Injectable()
export class ClickUpEffect {
  constructor(
    private actions$: Actions,
    private clickUpService: ClickUpService
  ) {}

  invokeAllCategoryNames$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeCreateClickUpTask),
      mergeMap((state) => {
        return this.clickUpService.createTask(state.createTask).pipe(
          map((data: SuccessDto | null) =>
            resultCreateClickUpTask({ result: data })
          ),
          catchError((error) =>
            of(
              setAPIStatus({
                apiStatus: {
                  apiResponseMessage: error,
                  apiStatus: "error",
                },
              })
            )
          )
        );
      })
    )
  );
}
